/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-rixml-info-guide-icon[_ngcontent-%COMP%]:hover{color:#414152;opacity:1}"];
export { styles as styles };
